import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid2 } from '@mui/material';
import { Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

export default function Login() {
  const [formData, setFormData] = React.useState({
    username: "",
    password: "",
  });
  let navi = useNavigate();

  const login = () => {
    // Check if the entered username and password are correct
    if (formData.username === "admin59adoop" && formData.password === "shop@OM89") {
      // If credentials match, proceed with the API call
      fetch(`https://api.adoop.in/api/auth/master_login`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
        toast.success(data.message);
        setFormData({
          username: 'admin59adoop',
          password: 'shop@OM89',
        });

        toast.success("Master Login Successfully");
        localStorage.setItem('accessToken',data.accessToken);
        console.log(data.accessToken);
        
        navi('/admin');
      })
      .catch(error => {
        console.error(error);
        toast.error("An error occurred while logging in.");
      });
    } else {
      // If credentials do not match, show an error message
      toast.error("Invalid username or password.");
    }
  };

  return (
    <Grid2
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}  // This ensures that the container takes the full height of the viewport
    >
      <Card sx={{ minWidth: 275 }} style={{ border: "1px solid gold", boxShadow: "1px 1px gold" }}>
        <Form>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Welcome to <span style={{ color: "gold" }}>Adoop</span>
            </Typography>

            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                style={{ marginLeft: "55px", padding: "10px" }}
                placeholder='Enter Mobile Number'
                type="text"
                name="name"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              />
            </Form.Group>
            <br />
            <Form.Group>
              <Form.Label>Password</Form.Label>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <Form.Control
                style={{ marginLeft: "20px", padding: "10px" }}
                placeholder='Enter Password'
                type="password"
                name="name"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
            </Form.Group>
            <br />
          </CardContent>
          <CardActions style={{ display: "flex", justifyContent: "center" }}>
            <Button variant='contained' style={{ background: "gold", color: "black" }} onClick={login}>Login</Button>
          </CardActions>
        </Form>
      </Card>
    </Grid2>
  );
}
